import { forwardRef } from "react";
import Slide from "@mui/material/Slide";

const OrderEstimationTransition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default OrderEstimationTransition;
